import React, {useEffect} from 'react'
import {PageHeader} from "../../../components/common/pageHeader/PageHeader";
import {useNavigate, useSearchParams} from "react-router-dom";
import {URL_NOTIFICATIONS_CREATE} from "../../../mock/page_urls";
import {Pagination} from "../../../components/common/pagination/Pagination";
import {useQuery} from "react-query";
import {getNotifications} from "../../../services/notificationSvc";
import {NotificationCard} from "../../../components/common/notificationCard/NotificationCard";
import {KTIcon, useDebounce} from "../../../../_metronic/helpers";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {separateFormatter} from "../../../utils/separateFormatter";

export const NotificationsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const searchQuery = searchParams.get("search") || ""

  const debouncedSearch = useDebounce(searchQuery, 500);

  const {
    data: notificationData,
    isLoading: notificationIsLoading,
    refetch: refetchNotification
  } = useQuery(["getNotifications", page, debouncedSearch], () => getNotifications({
    params: {
      page,
      page_size: 10,
      search: debouncedSearch
    }
  }), {
    keepPreviousData: true,
  })

  const navigate = useNavigate()

  const pageDetails = {
    title: "Xabarlar",
    desc: `Jami xabarlar soni: (${separateFormatter(notificationData?.total_items || 0, " ", "ta")})`,
    buttons: [{
      onClick: () => navigate(URL_NOTIFICATIONS_CREATE),
      text: "Qo'shish",
      icon: "plus-square",
    }]
  };

  const totalItems = notificationData?.total_items || 0;
  const itemsPerPage = notificationData?.page_size || 8;

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchParams({page: "1", search: query});
  }

  useEffect(() => {
    if (debouncedSearch) {
      refetchNotification();
    }
  }, [debouncedSearch, refetchNotification]);

  return (
      <div>
        <PageHeader pageDetails={pageDetails}/>
        <div className={"d-flex flex-wrap justify-content-between align-items-center rounded py-1 mb-5"}>
          <div className={"w-100 w-100 w-md-250px"}>
            <div className="d-flex align-items-center position-relative my-1">
              <KTIcon iconName={"magnifier"} className={"fs-1 position-absolute ms-3"}/>
              <input type="text" data-kt-user-table-filter="search"
                     className="form-control w-100 w-md-250px ps-12"
                     placeholder="Qidiruv..." value={searchQuery}
                     onChange={handleSearchChange}/>
            </div>
          </div>
        </div>

        {
          notificationIsLoading ? (
              <LoaderSection height={"50vh"}/>
          ) : notificationData?.data?.length === 0 ? <EmptySection height={"50vh"}/> : (
              <div>
                {notificationData?.data?.map((notificationItem) => (
                    <NotificationCard key={notificationItem?.id} refetchNotification={refetchNotification}
                                      notificationItem={notificationItem}/>
                ))}
                <div className={"my-10"}>
                  <Pagination
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                  />
                </div>
              </div>
          )
        }
      </div>
  )
}
